/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} HighInputs */

const en_high = /** @type {(inputs: HighInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`High`)
};

const th_high = /** @type {(inputs: HighInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สูง`)
};

const ja_high = /** @type {(inputs: HighInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`高`)
};

const fr_high = /** @type {(inputs: HighInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Élevé`)
};

const es_high = /** @type {(inputs: HighInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alto`)
};

const ru_high = /** @type {(inputs: HighInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Высокий`)
};

const zh_high = /** @type {(inputs: HighInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`高`)
};

const vi_high = /** @type {(inputs: HighInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cao`)
};

/**
* | output |
* | --- |
* | "High" |
*
* @param {HighInputs} inputs
* @param {{ locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }} options
* @returns {LocalizedString}
*/
export const high = /** @type {((inputs?: HighInputs, options?: { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<HighInputs, { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_high(inputs)
	if (locale === "ja") return ja_high(inputs)
	if (locale === "fr") return fr_high(inputs)
	if (locale === "es") return es_high(inputs)
	if (locale === "ru") return ru_high(inputs)
	if (locale === "zh") return zh_high(inputs)
	if (locale === "vi") return vi_high(inputs)
	return en_high(inputs)
});